import React, { ComponentType } from 'react';
import { Outlet, useNavigate } from '@tanstack/react-router';

import Button from 'components/core/Button';
import Text from 'components/core/Text';
import { SettingsIcon, StoriesIcon, TIconProps, UsersIcon } from 'components/Icons';

import { clearSession } from 'configs/requestConfig';

import {
  StyledBrand,
  StyledContent,
  StyledLogoMark,
  StyledNav,
  StyledNavItem,
  StyledShell,
  StyledSidebar,
} from './MainLayout.styles';

type TNavItem = {
  to: string;
  label: string;
  Icon: ComponentType<TIconProps>;
  exact?: boolean;
};

const NAV_ITEMS: TNavItem[] = [
  { to: '/', label: 'Stories', Icon: StoriesIcon, exact: true },
  { to: '/audiences', label: 'Audiences', Icon: UsersIcon },
  { to: '/settings', label: 'Settings', Icon: SettingsIcon },
];

const MainLayout = () => {
  const navigate = useNavigate();

  const signOut = () => {
    // Both halves: leaving the refresh token behind would let the next 401 silently restore the
    // session the user just ended.
    clearSession();
    navigate({ to: '/login' });
  };

  return (
    <StyledShell>
      <StyledSidebar>
        <StyledBrand>
          <StyledLogoMark>S</StyledLogoMark>
          Spotlight
          <Text variant="body" color="textMuted">
            Studio
          </Text>
        </StyledBrand>

        <StyledNav>
          {NAV_ITEMS.map(({ to, label, Icon, exact }) => (
            <StyledNavItem key={to} to={to} activeOptions={{ exact: Boolean(exact) }}>
              <Icon size={18} />
              {label}
            </StyledNavItem>
          ))}
        </StyledNav>

        <Button variant="ghost" size="sm" onClick={signOut}>
          Sign out
        </Button>
      </StyledSidebar>

      <StyledContent>
        <Outlet />
      </StyledContent>
    </StyledShell>
  );
};

export default MainLayout;
